// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lEkscWI5do4mEZ5cmR3e {
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--xds-color-orange-30);
  margin-top: 48px;
}

@media (max-width: 575.98px) {
  .lEkscWI5do4mEZ5cmR3e {
    margin-top: inherit;
  }
}

.CqKBsgnTexrjCY_E9h63 {
  width: 100%;
  max-width: 106px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/style.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".header {\n  height: 72px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--xds-color-orange-30);\n  margin-top: 48px;\n}\n\n@media (max-width: 575.98px) {\n  .header {\n    margin-top: inherit;\n  }\n}\n\n.logo {\n  width: 100%;\n  max-width: 106px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `lEkscWI5do4mEZ5cmR3e`,
	"logo": `CqKBsgnTexrjCY_E9h63`
};
export default ___CSS_LOADER_EXPORT___;
